import { Input } from '@cocoonspace/ui/components/input'
import { Tabs, TabsList, TabsTrigger } from '@cocoonspace/ui/components/tabs'
import {
	ToggleGroup,
	ToggleGroupItem,
} from '@cocoonspace/ui/components/toggle-group'
import { useLingui } from '@lingui/react/macro'
import {
	CalendarArrowDownIcon,
	CalendarArrowUpIcon,
	SearchIcon,
} from 'lucide-react'

import { useInvoicesFilters } from './use-invoices-filters.hook'

export const InvoiceFilters = () => {
	const { t } = useLingui()

	const [filters, setFilters] = useInvoicesFilters()

	return (
		<div className='flex flex-col items-end gap-4 md:flex-row md:gap-8'>
			{!filters.searchTerms && (
				<Tabs
					className='mr-auto'
					onValueChange={(activeTab) => {
						setFilters({
							activeYear: Number(activeTab),
						})
					}}
					value={filters.activeYear.toString()}
				>
					<TabsList>
						{[
							new Date().getFullYear(),
							new Date().getFullYear() - 1,
							new Date().getFullYear() - 2,
						].map((year) => (
							<TabsTrigger
								key={year}
								value={year.toString()}
							>
								{year}
							</TabsTrigger>
						))}
					</TabsList>
				</Tabs>
			)}

			<div className='flex items-center gap-4 max-md:hidden md:ml-auto'>
				<ToggleGroup
					onValueChange={(value) => {
						if (!value) return
						setFilters({ sortOrder: value as 'asc' | 'desc' })
					}}
					type='single'
					value={filters.sortOrder}
				>
					<ToggleGroupItem value='asc'>
						<CalendarArrowUpIcon />
					</ToggleGroupItem>

					<ToggleGroupItem value='desc'>
						<CalendarArrowDownIcon />
					</ToggleGroupItem>
				</ToggleGroup>

				<div className='relative w-[250px] max-md:hidden'>
					<SearchIcon
						className='absolute top-1/2 left-2.5 -translate-y-1/2'
						size={18}
					/>

					<Input
						aria-label={t`Rechercher une facture`}
						className='pl-8'
						onChange={(event) => {
							setFilters({
								searchTerms: event.target.value || null,
							})
						}}
						placeholder={t`Rechercher une facture`}
						value={filters.searchTerms || ''}
						variant='noBorder'
					/>
				</div>
			</div>
		</div>
	)
}
